(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1768f9a"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ai-blog-slider')) {
    customElements.define('ai-blog-slider', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.scroller) return;
        this.ac = new AbortController();
        const o = { signal: this.ac.signal };
        const step = (dir) => {
          const card = this.scroller.querySelector('.ai-bl__card');
          const gap = parseFloat(getComputedStyle(this.scroller.firstElementChild).columnGap) || 0;
          const by = card ? (card.offsetWidth + gap) * dir : this.scroller.clientWidth * 0.8 * dir;
          this.scroller.scrollBy({ left: by, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.prev?.addEventListener('click', () => step(-1), o);
        this.next?.addEventListener('click', () => step(1), o);
        this.scroller.addEventListener('keydown', (e) => {
          if (e.target !== this.scroller) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        }, o);
        this.scroller.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal: this.ac.signal });
        new ResizeObserver(() => this.updateArrows()).observe(this.scroller);
        this.updateArrows();
      }
      disconnectedCallback() { this.ac?.abort(); }
      updateArrows() {
        const s = this.scroller, max = s.scrollWidth - s.clientWidth - 1;
        const x = Math.abs(s.scrollLeft);
        if (this.prev) this.prev.disabled = x <= 1;
        if (this.next) this.next.disabled = x >= max;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
